import { render, staticRenderFns } from "./CCategoryButton.vue?vue&type=template&id=31085590&scoped=true"
import script from "./CCategoryButton.vue?vue&type=script&lang=js"
export * from "./CCategoryButton.vue?vue&type=script&lang=js"
import style0 from "./CCategoryButton.vue?vue&type=style&index=0&id=31085590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31085590",
  null
  
)

export default component.exports